import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Components from './components/components';
import HotTopicDetail from '../components/hotTopicDetail';

import './ppd.less';
import './ppd-en.less';
import './ppd.theme.less';

export interface IPPIIProps {
  topicName: string;
  topicSettings: any[];
}

export function PPD(props: IPPIIProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={
          <HotTopicDetail
            settings={props.topicSettings}
            components={Components}
          />
        }
      />
    </Routes>
  );
}
